import React, { FC, ReactNode } from 'react';
import { IUser } from 'types';
import styles from './ProfileView.module.scss';
import {ReactComponent as UserIcon} from 'icons/user_icon.svg';

interface Props {
  data: IUser;
}

type ProfileAttributes = keyof Pick<IUser, 'inn' | 'phone' | 'email'>;

const Attributes: {
  [key in ProfileAttributes]: {
    label: string;
    format?: (val: any) => ReactNode;
  };
} = {
  inn: { label: 'ИНН' },
  phone: { label: 'Телефон', format: (val) => `+7 (${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6, 8)}-${val.slice(8, 10)}` },
  email: { label: 'e-mail' },
};

export const ProfileView: FC<Props> = ({ data }) => {
  return (
   
    <div className={styles.wrapper}>
      <div className={styles.content}>
       <div className={styles.avatar}>
        <UserIcon/>
        </div>
        <div className={styles.container}>
         <div className={styles.row}>
          <div className={styles.column}>
            <div className={styles.value}>{data.lastName}</div>
            <div className={styles.label}>Фамилия</div>
          </div>
          <div className={styles.column}>
            <div className={styles.value}>{data.firstName}</div>
            <div className={styles.label}>Имя</div>
          </div>
          <div className={styles.column}>
            <div className={styles.value}>{data.middleName}</div>
            <div className={styles.label}>Отчество</div>
          </div>
        </div>
        {/* Дополнительные данные */}
        <div className={styles.row}>
          {Object.keys(Attributes).map((key) => {
            const attr = Attributes[key as ProfileAttributes];
            const value = data[key as ProfileAttributes];
            return (
              <div key={key} className={styles.column}>
                <div className={styles.value}>
                  {attr.format ? attr.format(value) : value}
                </div>
                <div className={styles.label}>{attr.label}</div>
              </div>
            );
          })}
        </div>
        </div>
      </div>
      </div>
  );
};
